<style lang="scss" scoped>
.sub-header {
  display: flex;
  padding: 0 32px;
  color: #666;
  font-size: 14px;

  .question-num {
    flex: 1;
    line-height: 60px;
  }
}

.refresh-btn {
  float: right;
  height: 60px;
  line-height: 60px;
  color: #666;
  font-size: 14px;

  > label {
    display: inline-block;
    margin-left: 10px;
    color: $color-theme;
    text-decoration: underline;
    cursor: pointer;

    &:hover {
      font-weight: bold;
    }
  }
}

.chart {
  margin: 0 60px 0;
}

#readQualityChart {
  height: 300px;
}

.table-wrapper {
  ::v-deep .el-table th {
    font-size: 13px !important;
  }
}
</style>

<template>
  <div>
    <div class="sub-header">
      <div class="question-num">
        <span>题号：</span>
        <el-select value-key="num" style="width:180px;" v-model="currentQuestion">
          <el-option v-for="(q, i) in questionList" :key="i" :label="`${q.bigNum || ''}${q.smallNum || ''}`" :value="q">
            <join-topic :direction="'row'" :fontSize="14" :texts="[q.bigNum, q.smallNum]" :nullText="q.question" />
          </el-option>
        </el-select>
      </div>
      <div class="refresh-btn">
        <span>数据统计截止到 {{ updated_at }}</span>
        <label @click="getReadQuality()">刷新</label>
      </div>
    </div>

    <div class="chart">
      <div id="readQualityChart"></div>
    </div>

    <div class="table-wrapper" style="margin: 16px 32px">
      <el-table size="small" class="table-mini-th" max-height="750px" border :data="qualityTableData" :row-class-name="rowClass">
        <el-table-column label="老师姓名" align="center" prop="teacherName"></el-table-column>
        <el-table-column label="批阅角色" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.teacherType == 1">批阅老师</span>
            <span v-if="scope.row.teacherType == 2">仲裁老师</span>
            <span v-if="scope.row.teacherType == 3">三评老师</span>
            <span v-if="scope.row.teacherType == 4">批阅组长</span>
          </template>
        </el-table-column>
        <el-table-column label="阅卷总任务" min-width="110px" sortable align="center" prop="totalCount"></el-table-column>
        <el-table-column label="已阅卷" align="center" sortable prop="alreadyCount"></el-table-column>
        <el-table-column label="平均分" align="center" sortable prop="avgScore">
          <template slot-scope="scope">
            <span>{{ scope.row.avgScore ? scope.row.avgScore.toFixed(2) : scope.row.avgScore }}</span>
          </template>
        </el-table-column>
        <el-table-column label="最高分" sortable align="center" prop="maxScore"></el-table-column>
        <el-table-column label="最低分" sortable align="center" prop="minScore"></el-table-column>
        <el-table-column min-width="150px" label="阅卷速度（秒/份）" sortable align="center" prop="avgGradingTime">
          <template slot-scope="scope">
            <span>{{ scope.row.avgGradingTime ? scope.row.avgGradingTime.toFixed(2) : scope.row.avgGradingTime }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="130px" label="抽样复评一致率" sortable align="center" prop="reviewAccuracyRate">
          <template slot-scope="scope">
            <div v-if="scope.row.teacherType == 1">
              <span v-if="scope.row.reviewAccuracyRate !== null">{{ parseFloat(scope.row.reviewAccuracyRate).toFixed(2) }}%</span>
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import echarts from "echarts/lib/echarts";
import "echarts/lib/component/title";
import "echarts/lib/component/markLine";
import "echarts/lib/component/legend";
import "echarts/lib/component/legendScroll";
import "echarts/lib/component/dataZoom";
import "echarts/lib/component/dataZoomInside";
import "echarts/lib/component/tooltip";
import { getExamQuestions } from "@/api/exam/marking";
import util from "@/utils/util";
import { gradingApi } from '@/v2/utils/api'
import JoinTopic from "@/components/JoinTopic";
export default {
  components: {
    JoinTopic
  },
  data () {
    return {
      seriesList: [],
      teacherNameList: [],
      examName: "",
      subjectName: "",
      gradeName: "",
      currentQuestion: {},
      questionList: [],
      currentType: 1,
      avgScore: "",
      teacherScore: [],
      qualityTableData: [],
      distribution_curve: [],
      distribution_table: [],
      score_group: [],
      updated_at: "",
      loading: false
    };
  },
  props: {
    isClassMark: {
      type: Boolean,
      default: () => false
    }
  },
  watch: {
    currentQuestion (val) {
      this.getReadQuality();
    }
  },

  mounted () {
    this.getQuestionList();
  },

  methods: {
    rowClass ({ row, rowIndex }) {
      if (row.reviewAccuracyStatus) {
        return "highLightRow";
      }
    },

    async getQuestionList () {
      let res = await getExamQuestions({
        examId: this.$route.params.id,
        teacherId: ''
      });
      if (res.success) {
        this.questionList = res.body;
        if (this.questionList.length > 0) {
          this.currentQuestion = this.questionList[0];
        }
      } else {
        this.$message.error(res.message);
      }
    },

    async getReadQuality () {
      this.loading = true;
      const params ={
        examId: this.$route.params.id,
        schoolId: this.$route.query.schoolId,
        num: this.currentQuestion.num
      }
      let method = 'queryQualityData'
      if (this.$route.query.isRegion + '' === 'true') {
        params.regionId = this.$route.query.regionId
        method = 'getQualityData'
      }


      let res = await gradingApi[method](params);
      this.loading = false;
      if (res.code == 200) {
        this.avgScore = res.result.avgChart.avgScore;
        const list = res.result.avgChart.teacherScore;
        for (let index = 0; index < list.length; index++) {
          const element = list[index];
          element.teacherName = this.getTeacherName(element)
        }
        this.teacherScore = list;
        const list2 = res.result.statisticsTable.statisticsRows;
        for (let index = 0; index < list2.length; index++) {
          const element = list2[index];
          element.teacherName = this.getTeacherName(element)
        }
        this.qualityTableData = list2;
        if (res.result.date) {
          this.updated_at = util.formatDate(res.result.date, "ymdhis");
        } else {
          this.updated_at = "";
        }
        this.drawReadQuality();
      } else {
        this.avgScore = "";
        this.teacherScore = [];
        this.qualityTableData = [];
        this.drawReadQuality();
        this.$message.error(res.message);
      }
    },

    drawReadQuality () {
      let that = this;
      let option = {
        title: {
          left: "center",
          top: 20,
          text: "各阅卷老师平均分柱状图"
        },
        grid: {
          // left: '5%',
          right: "5%"
        },
        dataZoom: [
          {
            show: this.teacherScore.length > 30 ? true : false,
            start: 0,
            end: Math.ceil((30 / this.teacherScore.length) * 100),
            bottom: 30
          }
        ],
        tooltip: {
          show: true,
          formatter: "{b}:{c}分"
        },
        legend: {
          selectedMode: false,
          right: 150,
          top: 30,
          data: [
            {
              name: "老师"
            },
            {
              name: "题组平均",
              icon:
                "image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAAPCAYAAACrxeyFAAABfGlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGAqSSwoyGFhYGDIzSspCnJ3UoiIjFJgv8PAzcDDIMRgxSCemFxc4BgQ4MOAE3y7xsAIoi/rgsxK8/x506a1fP4WNq+ZclYlOrj1gQF3SmpxMgMDIweQnZxSnJwLZOcA2TrJBUUlQPYMIFu3vKQAxD4BZIsUAR0IZN8BsdMh7A8gdhKYzcQCVhMS5AxkSwDZAkkQtgaInQ5hW4DYyRmJKUC2B8guiBvAgNPDRcHcwFLXkYC7SQa5OaUwO0ChxZOaFxoMcgcQyzB4MLgwKDCYMxgwWDLoMjiWpFaUgBQ65xdUFmWmZ5QoOAJDNlXBOT+3oLQktUhHwTMvWU9HwcjA0ACkDhRnEKM/B4FNZxQ7jxDLX8jAYKnMwMDcgxBLmsbAsH0PA4PEKYSYyjwGBn5rBoZt5woSixLhDmf8xkKIX5xmbARh8zgxMLDe+///sxoDA/skBoa/E////73o//+/i4H2A+PsQA4AJHdp4IxrEg8AAABcSURBVEgNY/zx889/hmEEmIaRX8BeGfXQYI/RYRdDLAw/Xg/2QCfJfSz/7ywgScNgV8zC8PbsYHcjSe5j/H53y7CqhxhHK1aSEgD9FQ+7YnvUQ/RPRKTZOOxiCAAQnBGZf519JwAAAABJRU5ErkJggg=="
            }
          ]
        },
        xAxis: {
          name: "老师",
          type: "category",
          data: this.teacherScore.map(t => t.teacherName),
          splitLabel: {
            show: false
          },
          splitLine: {
            show: false
          },
          splitArea: {
            show: false
          }
        },
        yAxis: {
          name: "平均分",
          type: "value"
        },
        series: [
          {
            name: "题组平均",
            type: "line",
            data: []
          },
          {
            itemStyle: {
              barBorderRadius: [10, 10, 10, 10],
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#447ED9"
                },
                {
                  offset: 1,
                  color: "#8EB7F6"
                }
              ])
            },
            name: "老师",
            data: this.teacherScore.map(t =>
              t.avgScore ? t.avgScore.toFixed(2) : t.avgScore
            ),
            type: "bar",
            barWidth: 20,
            markLine: {
              data: [
                {
                  name: "题组平均",
                  yAxis: this.avgScore
                }
              ],
              lineStyle: {
                color: "#F8BB46",
                type: "solid",
                width: 2
              }
            }
          }
        ]
      };
      let barChart = echarts.init(document.getElementById("readQualityChart"));
      this.$nextTick(() => {
        barChart.setOption(option);
        barChart.resize();
      });
    },
    getTeacherName (element) {
      let className = ''
      if (this.isClassMark) {
        className = element.gradingClasses ? element.gradingClasses.map(s => s.className).join('、') : ''
      }
      return className + (className.length > 0 ? '-' : '') + (element.teacherName ? element.teacherName : element.teacherId.substring(element.teacherId.length - 6) + '(已删除)')
    }
  }
};
</script>
